export default ({change = null, name, type, required = false, label, min, initial = null}) => {
    const options = {
        required,
        name,
        type: type || "text",
        onChange: change || null,
        min: min || null,
    }

    if (type == "checkbox") options.checked = initial || false
    else options.value = initial || null


    return <div>
        <span>{label}</span>
        {type == "checkbox" ? <div><input {...options}/></div> : <input {...options}/>}
        { required ? <span class = "tk-required">*</span> : null }
    </div>
}